import { StructuredData } from './StructuredData';
import { FEATURES_FAQS } from '@/data/marketingContent';

const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Beatview",
  "applicationCategory": ["BusinessApplication", "RecruitmentSoftware"],
  "operatingSystem": "Web",
  "url": "https://beatview.ai/features",
  "description": "Beatview is an AI-powered hiring platform that automates candidate screening, structured video interviews, work style assessments, and pipeline management. Built for teams hiring at scale.",
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD",
    "description": "Free tier available with premium plans for teams"
  },
  "featureList": [
    "AI Resume Screening with job match scoring",
    "Structured Video and Audio Interviews",
    "Work Style Behavioral Assessment",
    "Visual Hiring Pipeline with Kanban board",
    "Intelligent Pipeline Automation",
    "White-labeled Career Pages",
    "Centralized Resume Bank",
    "Analytics Dashboard with hiring insights",
    "Secure Candidate Sharing",
    "Custom Domain Support",
    "Email Automation with templates",
    "Zapier, API access and webhooks on Enterprise"
  ],
  "screenshot": "https://beatview.ai/og-image.png",
  "softwareVersion": "1.0",
  "creator": {
    "@type": "Organization",
    "name": "Beatview",
    "url": "https://beatview.ai"
  },
  "softwareHelp": {
    "@type": "WebPage",
    "url": "https://platform.beatview.ai/docs"
  }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://beatview.ai"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Features",
      "item": "https://beatview.ai/features"
    }
  ]
};

const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": FEATURES_FAQS.map(item => ({ "@type": "Question", "name": item.question, "acceptedAnswer": { "@type": "Answer", "text": item.answer } }))
};

export function FeaturesStructuredData() {
  return <StructuredData data={[softwareApplicationSchema, breadcrumbSchema, faqPageSchema]} />;
}
